"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var stream_1 = require("stream");

exports.DEFAULT_INITIAL_SIZE = 8 * 1024;
exports.DEFAULT_INCREMENT_AMOUNT = 8 * 1024;
exports.DEFAULT_FREQUENCY = 1;
exports.DEFAULT_CHUNK_SIZE = 1024;

var DuplexBufferStream = function (_super) {
  __extends(DuplexBufferStream, _super);

  function DuplexBufferStream(initialSize, incrementAmount, frequency, chunkSize) {
    if (initialSize === void 0) {
      initialSize = exports.DEFAULT_INITIAL_SIZE;
    }

    if (incrementAmount === void 0) {
      incrementAmount = exports.DEFAULT_INCREMENT_AMOUNT;
    }

    if (frequency === void 0) {
      frequency = exports.DEFAULT_FREQUENCY;
    }

    if (chunkSize === void 0) {
      chunkSize = exports.DEFAULT_CHUNK_SIZE;
    }

    var _this = _super.call(this) || this;

    _this.initialSize = initialSize;
    _this.incrementAmount = incrementAmount;
    _this.frequency = frequency;
    _this.chunkSize = chunkSize;
    _this.buffer = Buffer.alloc(_this.initialSize);
    _this.size = 0;
    _this.allowPush = false;
    _this.stopped = false;
    _this.timeout = null;

    _this.sendData = function () {
      var amount = Math.min(_this.chunkSize, _this.size);
      var sendMore = false;

      if (amount > 0) {
        var chunk = Buffer.alloc(amount);

        _this.buffer.copy(chunk, 0, 0, amount);

        sendMore = _this.push(chunk) !== false;
        _this.allowPush = sendMore;

        _this.buffer.copy(_this.buffer, 0, amount, _this.size);

        _this.size -= amount;
      }

      if (_this.size === 0 && _this.stopped) {
        _this.push(null);
      }

      if (sendMore) {
        _this.timeout = setTimeout(_this.sendData, _this.frequency);
      } else {
        _this.timeout = null;
      }
    };

    return _this;
  }

  DuplexBufferStream.prototype.maxSize = function () {
    return this.buffer.length;
  };

  DuplexBufferStream.prototype.getContents = function (length) {
    if (!this.size) return '';
    var data = Buffer.alloc(Math.min(length || this.size, this.size));
    this.buffer.copy(data, 0, 0, data.length);
    if (data.length < this.size) this.buffer.copy(this.buffer, 0, data.length);
    this.size -= data.length;
    return data;
  };

  DuplexBufferStream.prototype.getContentsAsString = function (encoding, length) {
    if (!this.size) return '';
    var data = this.buffer.toString(encoding, 0, Math.min(length || this.size, this.size));
    var dataLength = Buffer.byteLength(data);
    if (dataLength < this.size) this.buffer.copy(this.buffer, 0, dataLength);
    this.size -= dataLength;
    return data;
  };

  DuplexBufferStream.prototype._write = function (chunk, encoding, done) {
    this.emit('data', chunk);
    this.increaseBufferIfNecessary(chunk.length);
    chunk.copy(this.buffer, this.size, 0);
    this.size += chunk.length;
    done();
  };

  DuplexBufferStream.prototype.increaseBufferIfNecessary = function (incomingDataSize) {
    if (this.buffer.length - this.size < incomingDataSize) {
      var factor = Math.ceil((incomingDataSize - (this.buffer.length - this.size)) / this.incrementAmount);
      var newBuffer = Buffer.alloc(this.buffer.length + this.incrementAmount * factor);
      this.buffer.copy(newBuffer, 0, 0, this.size);
      this.buffer = newBuffer;
    }
  };

  DuplexBufferStream.prototype.initiateSendData = function () {
    if (!this.timeout && this.allowPush) {
      this.timeout = setTimeout(this.sendData, this.frequency);
    }
  };

  DuplexBufferStream.prototype.stop = function () {
    this.stopped = true;
  };

  DuplexBufferStream.prototype._read = function () {
    this.allowPush = true;
    this.initiateSendData();
  };

  return DuplexBufferStream;
}(stream_1.Duplex);

exports.default = DuplexBufferStream;